
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {
  getSelectedDateRange,
  getCurrentSite
} from 'redux/modules/currentUser/selectors'
import {
  fetchInsightLandings,
  setChannelFilter
} from 'redux/modules/insights/actions'
import {
  getLandingsData,
  getLandingsDataFetching,
  getSelectedChannel
} from 'redux/modules/insights/selectors'
import {Table, Column, Cell} from 'components/Table'
import Loader from 'components/Loader'
import ChannelSelect from 'components/ChannelSelect'
import WithTooltip from 'components/WithTooltip'
import Iframe from 'components/Iframe'
import {connect} from 'react-redux'
import propsChanged from 'utils/propsChanged'
import {push as pushState} from 'react-router-redux'
import UpgradePanel from 'components/UpgradePanel'

export class LandingsInsightView extends React.Component {
  static propTypes = {
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    fetchInsightLandings: PropTypes.func,
    isLoading: PropTypes.bool,
    landingsData: PropTypes.array,
    selectedChannel: PropTypes.object,
    setChannelFilter: PropTypes.func,
    site: PropTypes.object,
    pushState: PropTypes.func.isRequired
  }

  static contextTypes = {
    permissions: PropTypes.object,
    timezone: PropTypes.string
  }

  componentDidMount() {
    const {timezone, permissions} = this.context
    const canViewLaningPages = permissions.show.includes('@features/landingPages')
    const {startDate, endDate, fetchInsightLandings, pushState} = this.props

    if (canViewLaningPages) {
      fetchInsightLandings(startDate, endDate, timezone)
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {timezone} = nextContext
    if (propsChanged(this.props, nextProps, ['startDate', 'endDate', 'selectedChannel'])) {
      const {startDate, endDate, fetchInsightLandings} = nextProps
      fetchInsightLandings(startDate, endDate, timezone)
    }
  }

  render() {
    const {permissions} = this.context

    const isAllowed = permissions.read.includes('@features/landingPages')
    if (!isAllowed) {
      return (
        <UpgradePanel fullWidth>
          <p>
            Get detailed statistics on how each of your landing pages perform to be able to optimize them. Upgrade now!
          </p>
        </UpgradePanel>
      )
    }
    return (
      <div className='landings-insight-view'>
        {this.renderFilter()}
        {this.renderTables()}
      </div>
    )
  }

  renderFilter() {
    const {selectedChannel} = this.props

    return (
      <div className='landings-insight-view_filter'>
        <div className='landings-insight-view_filter_text'>
          Filter results by channel or channel group
        </div>
        <ChannelSelect
          value={selectedChannel}
          onSelect={this.onSelect}
        />
      </div>
    )
  }

  renderTables() {
    const {landingsData} = this.props

    return (
      <div className='landings-insight-view_tables'>
        {landingsData ? landingsData.map(this.renderTable) : <Loader />}
      </div>
    )
  }

  renderTable = (tableData, index) => {
    const {isLoading, site} = this.props
    const {data, title} = tableData
    const {domain} = site
    const normalizedDomain = domain.includes('://') ? domain : `//${domain}`

    return (
      <div className='landings-insight-view_table-container' key={index}>
        <Table
          className='landings-insight-view_table'
          data={data}
          title={title}
          loading={isLoading}
          empty='No visits for the selected period and channel. Try another?'
          hover
        >
          <Column
            header='Landing page'
            cell={data => {
              const IframeTooltip = (
                <Iframe
                  src={`${normalizedDomain}${data.label}`}
                  width={1200}
                  height={600}
                  scale={0.3}
                />
              )
              return (
                <Cell>
                  <div className='landings-insight-view_table-pagename' title={data.label}>
                    <WithTooltip title={IframeTooltip}>
                      <a
                        className='landings-insight-view_table_link'
                        href={`${normalizedDomain}${data.label}`}
                        target='divvit_preview'
                      >
                        {data.label}
                      </a>
                    </WithTooltip>
                  </div>
                </Cell>
              )
            }
            }
            grow
          />
          <Column
            header={<Cell align='right'>Visits</Cell>}
            cell={data => <Cell format='number' align='right'>{data.traffic}</Cell>}
            width='110px'
          />
          <Column
            header={<Cell align='right'>CR</Cell>}
            cell={data => <Cell format='percent' align='right'>{data.cr}</Cell>}
            width='45px'
          />
          <Column
            header={<Cell align='right'>BR</Cell>}
            cell={data => <Cell format='percent' align='right'>{data.br}</Cell>}
            width='45px'
          />
          <Column
            header={<Cell align='right'>Value / Visit</Cell>}
            cell={data => <Cell format='currency' align='right'>{data.vpv}</Cell>}
            width='110px'
          />
          <Column
            header={<Cell align='right'>Revenue</Cell>}
            cell={data => <Cell format='currency' align='right'>{data.total}</Cell>}
            width='130px'
          />
        </Table>
      </div>
    )
  }

  onSelect = item => {
    const {setChannelFilter} = this.props
    if (!item) {
      setChannelFilter({
        channelId: null,
        channelGroupId: null
      })
    } else {
      const {channelGroupId, channelId} = item
      setChannelFilter({
        channelGroupId,
        channelId
      })
    }
  }
}

const mapStateToProps = (state, props) => {
  const {startDate, endDate} = getSelectedDateRange(state)
  const site = getCurrentSite(state)

  return {
    startDate,
    endDate,
    site,
    landingsData: getLandingsData(state),
    isLoading: getLandingsDataFetching(state),
    selectedChannel: getSelectedChannel(state)
  }
}

const mapDispatchToProps = {
  fetchInsightLandings,
  setChannelFilter,
  pushState
}

export default connect(mapStateToProps, mapDispatchToProps)(LandingsInsightView)



// WEBPACK FOOTER //
// ./client/views/LandingsInsightView/index.js